import PropTypes from "prop-types";
import React, {useState, useEffect} from "react";
import { injectIntl } from "react-intl";
import { Card, CardSection } from "cxa-components";
import messages from "components/messagesDescription";
import withMatchMediaProps from "@hocs/with-match-media-props";

const Step = ({ num, activeIndex, children }) => {

  return (
    <div
      className={`step-item  ${
        num == activeIndex ? "active-step" : num < activeIndex ? "completed-step" : ""
      }`}
    >
      {num > 0 && (
        <div className="step-connector">
          <span className="connector-line"></span>
        </div>
      )}
      <span className="step-content" >
        <button className={`step-btn`}>{num + 1}</button>
        <span className="step-label">
          {num == activeIndex && <strong>{children}</strong>}
          {num !== activeIndex && children}
        </span>
      </span>
    </div>
  );
};

const ClaimStepper = ({ index, intl, isNarrowScreen }) => {
  const [isSticky, setSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const stepNames = [
    intl.formatMessage(messages.claims.claimSubmissionSteps.step1),
    intl.formatMessage(messages.claims.claimSubmissionSteps.step2),
    intl.formatMessage(messages.claims.claimSubmissionSteps.step3),
    intl.formatMessage(messages.claims.claimSubmissionSteps.step4),
  ];
  return (
    <Card style={{ padding: "0" }} className="csp-side-menu">
      <CardSection>
        <div className="step-container" style={(isNarrowScreen && isSticky) ? {position: "fixed", width: "100vw", top: "-1rem ", zIndex: 10, backgroundColor: "#FFF", left: "0"} : {}}>
          {stepNames.map((name, idx) => {
            return (
              <Step key={idx} num={idx} activeIndex={index}>
                {name}
              </Step>
            );
          })}
        </div>
      </CardSection>
    </Card>
  );
};

ClaimStepper.propTypes = {
  intl: PropTypes.func,
  index: PropTypes.number,
};

export default injectIntl(
  withMatchMediaProps({
    isNarrowScreen: {
      maxWidth: 680,
    },
})(ClaimStepper));



// WEBPACK FOOTER //
// ./components/claim/ClaimStepper.js